module.exports = "<section class=\"pagenotfound\">\n  <h1>{{ 'Page not found' | translate | async }}</h1>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/404.html
// module id = ./src/app/Templates/404.html
// module chunks = main